// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    findMatchingAccount,
    findMatchingKey,
    isNotEmpty
} from '../../../../claim/shared/services/claim-shared-helper';
import AmountOfUse from '../../../../claim/shared/components/claim-fields/amount-of-use/amount-of-use-without-compliance';
import CustomerSearchField from './customer-search-field';
import Errors from './errors';
import FormActions from './registration-form-actions';
import FormValidation from '../../state/form-validation';
import LabeledDateInput from '../../../../claim/shared/components/claim-fields/labeled-date-input';
import LabeledInput from '../../../../claim/shared/components/claim-fields/labeled-input';
import LabeledInputWithBlur from '../../../../claim/shared/components/claim-fields/labeled-input-with-blur';
import LabeledKeyValueDropDown from '../../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import Registration from '@deere/cps-it.warranty-model-factory/lib/registration';
import RegistrationDomainValues from '../../state/registration-domain-values';
import RegistrationModals from '../../state/registration-modals';
import ResponsibleAccounts from '../../../../claim/shared/components/claim-fields/responsible-accounts';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {hasAccess} from '../../../../shared/services/security';
import {isValid} from '../../services/validations';
import {isValidDate} from '../../../../shared/services/build-date';
import moment from 'moment';

function handlePinBlur(pin) {

    this.actions.updateFormValidation('pin', pin);
    pin ? this.actions.readProductDetails(pin, true, this.registrationDomainValues.registrationTypes, '', this.registration.customer) : this.actions.resetProductDetails();

}

function handlePinChange(pin) {

    this.actions.updateRegistrationPin(pin);

}

function handleCreateCustomerClick(entityId) {

    this.actions.createRegistrationFormCustomer(entityId, this.product);

}

function handleCustomerKeyPress(event) {

    if (event.charCode === 13 || event.charCode === 32) {

        event.preventDefault();

        this.actions.updateRegistrationModals('customerSearchModal', !this.registrationModals.customerSearchModal);

    }

}

function handleCustomerSearchClick() {

    this.actions.updateRegistrationModals('customerSearchModal', !this.registrationModals.customerSearchModal);

}

function handleOpenDeleteModal() {

    this.actions.updateRegistrationModals('confirmDeleteModal', true);

}

function handleRegistrationSubmit(registerAnother, saveExistingRegistration = false) {

    this.actions.handleRegistrationSubmit(this.registration, this.user, registerAnother, saveExistingRegistration);

}

function handleDealerLocationInputChange(location) {

    this.actions.updateDealerLocation(location.toUpperCase());

}

function handleResponsibleAccountBlur(dealer) {

    this.actions.updateFormValidation('responsibleDealer', dealer);

}

function handleDealerLocationDropdownChange(account) {

    const responsibleDealer = findMatchingAccount(account, this.user.settings.dealer.accounts.registrationAllowedAccounts);

    this.actions.updateRegistration('responsibleDealer', responsibleDealer);

}

function handleRegistrationStatusBlur(event) {

    this.actions.updateFormValidation('registrationStatus', event.target.value);

    if (this.registration.statusIndicator.key === 'NEW' && this.product.customerSummary.id) {

        this.actions.updateFormValidation('registrationStatus', '');

    }

}

function handleRegistrationStatusChange(event) {

    const statusIndicator = findMatchingKey(event.target.value, this.registrationDomainValues.registrationTypes);

    this.actions.updateRegistration('statusIndicator', statusIndicator);

    if (event.target.value === 'NEW' && this.product.customerSummary.id) {

        this.actions.updateFormValidation('registrationStatus', '');

    }

}

function handleDeliveredDateBlur(event) {

    const deliveryDate = isValidDate(event.target.value) ? moment.utc(event.target.value).valueOf() : null;

    this.actions.updateFormValidation('deliveryDate', deliveryDate);

}

function handleDeliveredDateChange(deliveryDate) {

    this.actions.updateRegistration('deliveryDate', deliveryDate);

}

function handleFirstUseDateChange(firstUseDate) {

    this.actions.updateRegistration('firstUseDate', firstUseDate);

}

function handleUseAmountBlur(amount) {

    if (this.product.otherUnitRequired === 'N') {

        this.actions.updateFormValidation('useAmount', amount, this.registration);

    }

}

function handleUseAmountChange(amount) {

    this.actions.updateUseAmount('amount', amount);

}

function handleUseAmountOptionBlur(unit) {

    if (this.product.otherUnitRequired === 'N') {

        this.actions.updateFormValidation('useAmount', unit, this.registration);

    }

}

function handleUnitOptionChange(unitKey) {

    const useAmountUnit = findMatchingKey(unitKey, this.product.useAmountAllowedUnits);

    this.actions.updateUseAmount('unit', useAmountUnit);

}

function handleOtherUseAmountBlur(amount) {

    if (this.product.otherUnitRequired !== 'N') {

        this.actions.updateFormValidation('otherUseAmount', amount, this.registration);

    }

}

function handleOtherUseAmountChange(amount) {

    this.actions.updateOtherUseAmount('amount', amount);

}

function handleOtherUseAmountOptionBlur(unit) {

    if (this.product.otherUnitRequired !== 'N') {

        this.actions.updateFormValidation('otherUseAmount', unit, this.registration);

    }

}

function handleOtherUnitOptionChange(unitKey) {

    const otherUseAmountUnit = findMatchingKey(unitKey, this.registrationDomainValues.otherUseUnits);

    this.actions.updateOtherUseAmount('unit', otherUseAmountUnit);

}

function handlePurchaserTypeBlur(event) {

    this.actions.updateFormValidation('purchaserType', event.target.value);

}

function handlePurchaserTypeChange(event) {

    const purchaserType = findMatchingKey(event.target.value, this.registrationDomainValues.purchaseTypes);

    this.actions.updateRegistration('purchaserType', purchaserType);

}

function handleEndUseCodeBlur() {

    this.actions.updateFormValidation('endUseCode', event.target.value);

}

function handleEndUseCodeChange(event) {

    const endUseCode = findMatchingKey(event.target.value, this.registrationDomainValues.endUseCodes);

    this.actions.updateRegistration('endUseCode', endUseCode);

}

function handleLicensePlateChange(licensePlate) {

    this.actions.updateRegistration('licensePlate', licensePlate);

}

function handleOperatorsManualChange(operatorManualNumber) {

    this.actions.updateRegistration('operatorManualNumber', operatorManualNumber);

}

function handleCommentChange(comments) {

    this.actions.updateRegistration('comments', comments);

}

const getErrorMessage = key =>
    isNotEmpty(key) ? '' : 'REGISTRATION_STATUS_REQUIRED';

const getRegistrationStatusErrorMessage = (registration, product) =>
    registration.statusIndicator.key === 'NEW' && product.customerSummary.id ?
        'REGISTRATION_STATUS_CANNOT_BE_NEW' :
        getErrorMessage(registration.statusIndicator.key);

const isMachineAlreadyRegistered = (product, registration) => [
    isNotEmpty(product.customerSummary.id),
    isNotEmpty(registration.customer.id),
    product.customerSummary.id === registration.customer.id
].every(rule => rule);

const isEditSuccessfullRegistrationEditable = registration =>
(isNotEmpty(registration.status) && registration.status === 'SUCCESSFUL') || false;

/* eslint-disable complexity */

const Form = props =>
    <section className='product-registration-form'>
        <Errors
            errors={props.registration.errors}
        />
        <div className='row-one'>
            <LabeledInputWithBlur
                className={`pin required ${props.formValidation.pin ? '' : 'error'}`}
                errorMessage='PIN_REQUIRED'
                isEditable={!isEditSuccessfullRegistrationEditable(props.registration)}
                isValid={props.formValidation.pin}
                label='PIN'
                maxLength={18}
                onBlur={props::handlePinBlur}
                onChange={props::handlePinChange}
                tabIndex='1'
                value={props.registration.product.pin}
            />
            <CustomerSearchField
                customer={props.registration.customer}
                customerSearchModal={props.registrationModals.customerSearchModal}
                isCustomerEditable={!isEditSuccessfullRegistrationEditable(props.registration)}
                isCustomerInvalid={props.registration.id && !props.registration.customer.id}
                isMachineAlreadyRegistered={isMachineAlreadyRegistered(props.product, props.registration)}
                onCreateCustomerClick={props::handleCreateCustomerClick}
                onCustomerKeyPress={props::handleCustomerKeyPress}
                onCustomerSearchClick={props::handleCustomerSearchClick}
                showCustomerSearchIcon={!props.user.privacy.customerPrivate}
            />
            <FormActions
                handleOpenDeleteModal={props::handleOpenDeleteModal}
                handleSubmit={props::handleRegistrationSubmit}
                isDisabled={!props.registration.customer.id || !isValid(props.registration, props.product, props.security)}
                isEditRegistration={props.registration.id.length > 0}
                isUpdateRegistration={isEditSuccessfullRegistrationEditable(props.registration)}
                security={props.security}
                user={props.user}
            />
        </div>
        <div className='row-two'>
            {hasAccess(props.security, 'PRT', 'PRT_REGISTER_INTERNAL') || props.user.privacy.registrationNotAllowed ?
                <LabeledInput
                    className='dealer-location'
                    isEditable={!isEditSuccessfullRegistrationEditable(props.registration)}
                    label='DEALER_LOCATION'
                    maxLength={10}
                    onChange={props::handleDealerLocationInputChange}
                    tabIndex='3'
                    value={props.registration.responsibleDealer.account}
                /> :
                    <ResponsibleAccounts
                        dealers={props.user.settings.dealer.accounts.registrationAllowedAccounts}
                        errorMessage='ACCOUNT_NUMBER_REQUIRED'
                        highlightClass={`required ${props.formValidation.responsibleDealer ? '' : 'error'}`}
                        isEditable={!isEditSuccessfullRegistrationEditable(props.registration)}
                        isValid={props.formValidation.responsibleDealer}
                        onOptionBlur={props::handleResponsibleAccountBlur}
                        onOptionChange={props::handleDealerLocationDropdownChange}
                        selectedAccount={props.registration.responsibleDealer}
                        tabIndex='3'
                    />
            }
            <LabeledKeyValueDropDown
                className={`registration-status required ${props.formValidation.registrationStatus ? '' : 'error'}`}
                errorMessage={getRegistrationStatusErrorMessage(props.registration, props.product)}
                isEditable={!isEditSuccessfullRegistrationEditable(props.registration)}
                isValid={props.formValidation.registrationStatus}
                label='REGISTRATION_STATUS'
                list={props.registrationDomainValues.registrationTypes}
                onBlur={props::handleRegistrationStatusBlur}
                onChange={props::handleRegistrationStatusChange}
                selectedValue={props.registration.statusIndicator}
                tabIndex='4'
            />
        </div>
        <div className='row-three'>
            <LabeledDateInput
                className={`delivered-date required ${props.formValidation.deliveryDate ? '' : 'error'}`}
                date={props.registration.deliveryDate}
                errorMessage='DELIVERY_DATE_REQUIRED'
                isEditable={true}
                isValid={props.formValidation.deliveryDate}
                label='DELIVERED'
                maxDate={isEditSuccessfullRegistrationEditable(props.registration) ? moment.utc(props.previousDeliveryDate) : 0}
                minDate={isEditSuccessfullRegistrationEditable(props.registration) ? moment().subtract(5, 'years') : 0}
                onBlur={props::handleDeliveredDateBlur}
                onDateChange={props::handleDeliveredDateChange}
                placeholderText={props.user.getDateFormatValue()}
                tabIndex='5'
            />
            <LabeledDateInput
                className='first-use-date'
                date={props.registration.firstUseDate}
                isEditable={true}
                isValid={props.formValidation.firstUseDate}
                label='EXPECTED_FIRST_USE'
                onDateChange={props::handleFirstUseDateChange}
                placeholderText={props.user.getDateFormatValue()}
                tabIndex='6'
            />
            <AmountOfUse
                allowedUnits={props.product.useAmountAllowedUnits}
                className={`amount-of-use ${props.product.otherUnitRequired === 'N' ? 'required' : ''} ${props.formValidation.useAmount ? '' : 'error'}`}
                dropdownTabIndex='8'
                inputTabIndex='7'
                isEditable={isEditSuccessfullRegistrationEditable(props.registration) ? false : props.product.otherUnitRequired === 'N'}
                isValid={props.formValidation.useAmount}
                onInputBlur={props::handleUseAmountBlur}
                onInputChange={props::handleUseAmountChange}
                onOptionBlur={props::handleUseAmountOptionBlur}
                onOptionChange={props::handleUnitOptionChange}
                selectedUnit={props.registration.useAmount.unit}
                showBlankOption={true}
                value={props.registration.useAmount.amount}
            />
            <AmountOfUse
                allowedUnits={props.registrationDomainValues.otherUseUnits}
                className={`other-amount-of-use ${props.product.otherUnitRequired === 'Y' ? 'required' : ''} ${props.formValidation.otherUseAmount ? '' : 'error'}`}
                dropdownTabIndex='10'
                errorMessage='OTHER_AMOUNT_OF_USE_REQUIRED'
                inputTabIndex='9'
                isEditable={!isEditSuccessfullRegistrationEditable(props.registration)}
                isValid={props.formValidation.otherUseAmount}
                label='OTHER_AMOUNT_OF_USE'
                onInputBlur={props::handleOtherUseAmountBlur}
                onInputChange={props::handleOtherUseAmountChange}
                onOptionBlur={props::handleOtherUseAmountOptionBlur}
                onOptionChange={props::handleOtherUnitOptionChange}
                selectedUnit={props.registration.otherUseAmount.unit}
                showBlankOption={true}
                value={props.registration.otherUseAmount.amount}
            />
        </div>
        <div className='row-four'>
            <LabeledKeyValueDropDown
                className={`purchaser-type required ${props.formValidation.purchaserType ? '' : 'error'}`}
                errorMessage='PURCHASER_TYPE_REQUIRED'
                includeKeyInDropDown={true}
                isEditable={true}
                isValid={props.formValidation.purchaserType}
                label='PURCHASER_TYPE'
                list={props.registrationDomainValues.purchaseTypes}
                onBlur={props::handlePurchaserTypeBlur}
                onChange={props::handlePurchaserTypeChange}
                selectedValue={props.registration.purchaserType}
                tabIndex='11'
            />
            <LabeledKeyValueDropDown
                className={`end-use-code required ${props.formValidation.endUseCode ? '' : 'error'}`}
                errorMessage='END_USE_CODE_REQUIRED'
                includeKeyInDropDown={true}
                isEditable={true}
                isValid={props.formValidation.endUseCode}
                label='END_USE_CODE'
                list={props.registrationDomainValues.endUseCodes}
                onBlur={props::handleEndUseCodeBlur}
                onChange={props::handleEndUseCodeChange}
                selectedValue={props.registration.endUseCode}
                tabIndex='12'
            />
        </div>
        <hr/>
        <div className='row-five'>
            <LabeledInput
                className='license-plate'
                isEditable={true}
                label='LICENSE_PLATE_NUMBER'
                maxLength={20}
                onChange={props::handleLicensePlateChange}
                tabIndex='13'
                value={props.registration.licensePlate}
            />
            <LabeledInput
                className='operators-manual'
                isEditable={true}
                label='OPERATORS_MANUAL_NUMBER'
                maxLength={15}
                onChange={props::handleOperatorsManualChange}
                tabIndex='14'
                value={props.registration.operatorManualNumber}
            />
            <LabeledInput
                className='comment'
                isEditable={true}
                label='COMMENT'
                maxLength={120}
                onChange={props::handleCommentChange}
                tabIndex='15'
                value={props.registration.comments}
            />
        </div>
    </section>;

/* eslint-enable complexity */

Form.displayName = 'Form';
Form.propTypes = {
    actions: PropTypes.object.isRequired,
    formValidation: PropTypes.instanceOf(FormValidation).isRequired,
    previousDeliveryDate: PropTypes.number.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    registration: PropTypes.instanceOf(Registration).isRequired,
    registrationDomainValues: PropTypes.instanceOf(RegistrationDomainValues).isRequired,
    registrationModals: PropTypes.instanceOf(RegistrationModals).isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default Form;



// WEBPACK FOOTER //
// ./src/product/product-registration/components/product-registration-form/form.js